import { Fragment } from "react";
import { formatDayHeading, groupByReceptionDay } from "../../model/commandeListFormat";
import { visibleCommandes } from "../../model/commandeListRules";
import { CommandeMailRow } from "./CommandeMailRow";

// Lignes de la liste regroupées par jour de réception, sans les commandes en attente de suppression.
export function CommandeListRows({ commandes, pendingDeletes, rowState, showStatut, searchQuery, handlers }) {
    const { readOverrides, getFlag, focusedIndex, selectedCommandeId } = rowState;
    const visible = visibleCommandes(commandes, pendingDeletes);

    return (
        <div style={{ flex: 1, overflowY: "auto", minHeight: 0, padding: 0, display: "flex", flexDirection: "column", gap: 0, background: "#fffdfa" }}>
            {visible.length === 0 ? (
                <div style={{ padding: "64px", textAlign: "center", color: "#94a3b8", fontSize: "14px" }}>
                    Aucune commande
                </div>
            ) : groupByReceptionDay(visible).map(group => (
                <Fragment key={group.key}>
                    <div className="commande-day-heading">
                        <span>{formatDayHeading(group.dateReception)}</span>
                        <span aria-hidden="true">·</span>
                        <span>{group.items.length}</span>
                    </div>
                    {group.items.map(({ cmd, idx }) => (
                        <CommandeMailRow
                            key={cmd.id}
                            cmd={cmd}
                            idx={idx}
                            flags={{
                                isRead: readOverrides[cmd.id] || getFlag(cmd, "read"),
                                isFavorite: getFlag(cmd, "favorite"),
                                isFocused: idx === focusedIndex,
                                isSelected: cmd.id === selectedCommandeId,
                            }}
                            showStatut={showStatut}
                            searchQuery={searchQuery}
                            handlers={handlers}
                        />
                    ))}
                </Fragment>
            ))}
        </div>
    );
}
